<div class="m-333">
    <button mat-raised-button class="mb-05" color="primary" (click)="openPopUp({}, true)" *ngIf="addBtnName">
      {{addBtnName|translate}} </button>
  </div>
  <mat-card class="p-0" [@animate]="{value:'*',params:{y:'50px',delay:'300ms'}}">
    <mat-card-content class="p-0">
      <div class="table-container mat-elevation-z8 p-0" [@animate]="{value:'*',params:{y:'50px',delay:'300ms'}}">
        <table mat-table [dataSource]="items" matSort>
          <ng-container *ngFor="let column of columnDefinition; let i = index" matColumnDef="{{column.columnName}}">
          
             
                <ng-container *ngIf="!column.isMatrixColumn"> 

                    <ng-container *ngIf="!column.isLeftHeader">

                 
                    <th class="w-75" mat-sort-header mat-header-cell *matHeaderCellDef>
                        {{ (translatePrefix+column.columnName)|translate }}</th>
                        <ng-container *ngIf="!!!column.isEditable">
                          <td mat-cell class="td-table" *matCellDef="let row" attr.data-label="{{(translatePrefix+column.columnName) | translate}}">{{ row[column.columnName] != null ? row[column.columnName]
                            : '/'}}</td>
                        </ng-container>
                        <ng-container *ngIf="!!column.isEditable">
                          <td mat-cell class="td-table" *matCellDef="let row" attr.data-label="{{(translatePrefix+column.columnName) | translate}}">
                            <mat-form-field *ngIf="column.editableColumnType == 'number'">
                              <input matInput (input)="editableValueChanged(column.columnName, row, $event.target.value)"
                               type="number" value="{{row[column.columnName]}}" [disabled]="column.editableFieldDisabled(row)"/>
                            </mat-form-field>
                          </td>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!!column.isLeftHeader">

                 
                        <th class="w-75" mat-sort-header mat-header-cell *matHeaderCellDef>
                            </th>
                            <ng-container *ngIf="!transposedMatrix">
                                <td mat-cell class="td-table"  *matCellDef="let row">
                                    {{ (translatePrefix+'pitanje' )|translate }} {{ row[column.columnName]}}
                                       </td>
                            </ng-container>
                            <ng-container *ngIf="!!transposedMatrix">
                                <td mat-cell class="td-table"  *matCellDef="let row">
                                    {{ (translatePrefix+'odgovor' )|translate }} {{ row[column.columnName]}}
                                       </td>
                            </ng-container>
                        </ng-container>
                </ng-container>



             
                <ng-container *ngIf="!!column.isMatrixColumn">
                    <ng-container *ngIf="!transposedMatrix">
                        <th class="w-75" mat-sort-header mat-header-cell *matHeaderCellDef>
                            {{ (translatePrefix+'odgovor')|translate }} {{column.columnName}}</th> 
                    </ng-container>
                    <ng-container *ngIf="!!transposedMatrix">
                        <th class="w-75" mat-sort-header mat-header-cell *matHeaderCellDef>
                            {{ (translatePrefix+'pitanje')|translate }} {{column.columnName}}</th> 
                    </ng-container>
                    <td mat-cell class="td-table"  *matCellDef="let row; let rowIndex = index">
                         <mat-checkbox [checked]="row[column.columnName]" (change)="matrixCheckboxChanged(rowIndex, column.columnName, $event)" [disabled]="!!!enableMatrixEdit"></mat-checkbox>
                     
                     </td>
                </ng-container > 
              
              <td mat-footer-cell *matFooterCellDef style="text-align: left;">
                <!-- <mat-form-field style="margin-bottom: -1.25em; width:45%">
                <div *ngIf="!this.selectionFields.get(i)">
                  <input [formControl]="this.addForm.controls[column.columnName]" matInput type="text" />
                </div>
                <div *ngIf="this.selectionFields.get(i)">
                  <mat-select
                    (selectionChange)="this.addForm.controls[column.columnName].patchValue($event.value);column.columnName === 'methodCollectionType' ? selectionChanged($event): null">
                    <mat-option *ngFor="let val of this.selectionFields.get(i)" [value]=val>{{val}}</mat-option>
                  </mat-select>
                </div>
              </mat-form-field> -->
                <div style="height: 1.25em;">
                  <div
                    *ngIf="this.addForm.controls[column.columnName].dirty || this.addForm.controls[column.columnName].touched">
                    <mat-error style="font-size: smaller;"
                      *ngIf="this.addForm.controls[column.columnName].errors?.required">
                      {{'general.fieldRequired' | translate}}</mat-error>
                    <mat-error style="font-size: smaller;"
                      *ngIf="this.addForm.controls[column.columnName].errors?.maxlength">{{('general.maximalLength' |
                      translate) + this.addForm.controls[column.columnName].errors.maxlength.requiredLength}}</mat-error>
                  </div>
                </div>
              </td>
            
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row" >
              <ng-container *ngFor="let button of extraButtons">
                <button *ngIf="!button.hidden(row)" matTooltip="{{button.tooltip | translate}}" mat-icon-button mat-sm-button
                  color="primary" class="mr-1" (click)="extraBtnClick(row, button.btnAction)">
                  <mat-icon>{{button.icon}}</mat-icon>
                </button>
              </ng-container>
              <button data-testid="btnIzmeni" *ngIf="editButton" matTooltip="{{'general.edit'|translate}}" mat-icon-button mat-sm-button
                color="primary" class="mr-1" (click)="openPopUp(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="deleteButton" matTooltip="{{'general.delete'|translate}}" mat-icon-button mat-sm-button
                color="warn" class="mr-1" (click)="deleteItem(row)">
                <mat-icon>delete</mat-icon>
              </button>
              <button *ngIf="viewButton" matTooltip="{{'general.view'|translate}}" mat-icon-button mat-sm-button
                color="primary" (click)="viewItem(row)">
                <mat-icon>visibility</mat-icon>
              </button>
  
            </td>
            <td mat-footer-cell *matFooterCellDef style="text-align: center;">
              <button matTooltip="{{'general.add' | translate}}" class="mr-1" mat-icon-button mat-sm-button
                color="primary" (click)="addItem()" [disabled]="this.addForm.invalid">
                <mat-icon>add_circle</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container *ngIf="this.inputFooter">
            <tr mat-header-row *matHeaderRowDef="columnNames;"></tr>
            <tr mat-row *matRowDef="let row; columns: columnNames;">
            <tr mat-footer-row *matFooterRowDef="columnNames; sticky: true"></tr>
          </ng-container>
          <ng-container *ngIf="!this.inputFooter">
            <tr mat-header-row *matHeaderRowDef="columnNames;"></tr>
            <tr mat-row *matRowDef="let row; columns: columnNames;">
          </ng-container>
  
        </table>
        <div *ngIf="items && items.length==0" class="no-records">
          {{'general.noResults' | translate}}
        </div>
        <div *ngIf="showLoader">
          <mat-progress-bar mode="indeterminate" color="warn" class="session-progress "></mat-progress-bar>
        </div>
        <!-- <mat-paginator (page)="setPage($event)" [pageIndex]="numPage" [length]="totalElements" [pageSizeOptions]="[5, 10, 25]"
          showFirstLastButtons>
        </mat-paginator> -->
      </div>
    </mat-card-content>
  </mat-card>
  
  
  